<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "PaymentChannels",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                ],
                permission:{
                    add: 'paymentChannels:add',
                    update: 'paymentChannels:update',
                    delete: 'paymentPlatform:delete',
                    deleteBatch: 'paymentChannels:deleteBatch'
                },
                url: {
                    get: '/paymentChannels/listByCondition',
                    add: '/paymentChannels/add',
                    update: '/paymentChannels/update',
                    delete: '/paymentChannels/delete/',
                    delete_batch: '/paymentChannels/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                },{
                    field: 'name',
                    label: '渠道名称',
                    show: true,
                    width: '',
                }, {
                    field: 'channelType',
                    label: '渠道类型',
                    show: true,
                    width: '',
                }, {
                    field: 'pfId',
                    label: '平台ID',
                    show: {
                        type: 'select'
                    },
                    selectUrl: 'paymentPlatform/getAll',
                    selectData: [],
                    width: '',
                }, {
                    field: 'minMoney',
                    label: '最低金额',
                    show: {
                        type: 'money'
                    },
                    width: '',
                }, {
                    field: 'maxMoney',
                    label: '最高金额',
                    show: {
                        type: 'money'
                    },
                    width: '',
                }, {
                    field: 'type',
                    label: '使用平台',
                    show: {
                        type : 'select'
                    },
                    selectUrl: '',
                    selectData: [
                        {
                            id: 0,
                            name: 'android'
                        },
                        {
                            id: 1,
                            name: 'ios'
                        },
                        {
                            id: 2,
                            name: 'h5'
                        }
                    ],
                    width: '',
                }, {
                    field: 'returnUrl',
                    label: '同步返回地址',
                    show: true,
                    width: '',
                }, {
                    field: 'status',
                    label: '状态',
                    show: true,
                    status: true,
                    width: '',
                }, {
                    field: 'rank',
                    label: '排序',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加支付渠道',
                    updateTitle: '修改支付渠道',
                    model: [{
                        field: 'name',
                        label: '渠道名称：',
                        type: 'input',
                        placeholder: '渠道名称',
                        rules:[{message: '请输入渠道名称', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',
                        label: '渠道类型：',
                        type: 'input',
                        placeholder: '渠道类型',
                        rules:[{message: '请输入渠道类型', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'pfId',
                        label: '平台ID：',
                        type: 'select',
                        selectUrl: 'paymentPlatform/getAll',
                        selectData: [],
                        placeholder: '平台ID',
                        rules:[{message: '请选择平台', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'minMoney',
                        label: '最低金额(分)：',
                        type: 'input',
                        placeholder: '最低金额',
                        rules:[{message: '请输入最低金额', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'maxMoney',
                        label: '最高金额(分)：',
                        type: 'input',
                        placeholder: '最高金额',
                        rules:[{message: '请输入最高金额', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'type',
                        label: '使用平台：',
                        type: 'select',
                        selectUrl: '',
                        selectData: [
                            {
                                id: 0,
                                name: 'android'
                            },
                            {
                                id: 1,
                                name: 'ios'
                            },
                            {
                                id: 2,
                                name: 'h5'
                            }
                        ],
                        placeholder: '使用平台',
                        rules:[{message: '请输入使用平台', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'returnUrl',
                        label: '同步返回地址：',
                        type: 'input',
                        placeholder: '同步返回地址',
                        rules:[{message: '请输入同步返回地址', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'rank',
                        label: '排序：',
                        type: 'input',
                        placeholder: '排序',
                        rules:[{message: '请输入排序', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
